import React, { useState, useEffect } from "react";
import { send } from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ContactPage.css";

const jokeList = [
  "Why did the developer go broke? 💸 Because he used up all his cache.",
  "Why do I drink coffee? ☕ So I can write bugs faster with enthusiasm.",
  "My code works... I have no idea why. 🤷‍♂️",
  "Why did the computer get cold? 🥶 Because it forgot to close its Windows.",
  "I told my code to clean itself. It ran away. 🧼🏃‍♂️",
  "Real devs count from 0. So technically, you're already late. ⏱️",
  "Stack Overflow is my co-pilot. 🛫 Google is the senior dev. 👨‍💻",
  "Git commit -m 'Fixed a bug' 🐛 //and introduced 3 more 🔥🔥🔥",
  "CSS is like Tinder: keep swiping until something looks right. 💅",
  "I'm not lazy. I'm just in energy-saving mode. 🔋",
  "Debugging is like being the detective 🕵️‍♂️ in a crime movie where you are also the murderer. 😅",
  "404: Joke not found 😂",
  "Why do Java developers wear glasses? Because they can't C#. 👓",
  "Cloud is just someone else's computer ☁️💻",
  "I like my coffee like I like my code: strong and never unattended ☕💪",
  "There are 10 types of people: those who understand binary and those who don't. 💻",
];

const ContactPage = () => {
  const [joke, setJoke] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const randomJoke = jokeList[Math.floor(Math.random() * jokeList.length)];
    setJoke(randomJoke);
  }, []);

  const onFormSubmit = (event) => {
    event.preventDefault();

    if (!name || !email || !subject || !message) {
      toast.warn("⚠️ Please fill in all fields before submitting.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setIsLoading(true);
    const currentTime = new Date().toLocaleString();

    send(
      process.env.REACT_APP_SERVICE_ID,
      process.env.REACT_APP_TEMPLATE_ID,
      {
        name: name,
        title: subject,
        subject: subject,
        message: message,
        email: email,
        reply_to: email,
        time: currentTime,
        joke: joke
      },
      process.env.REACT_APP_USER_ID
    )
      .then(() => {
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
        toast.success("✅ Message sent successfully! Thanks for reaching out 😊", {
          position: "top-right",
          autoClose: 3000,
        });
        setIsLoading(false);
      })
      .catch(() => {
        toast.error("❌ Message failed to send, please try again later.", {
          position: "top-right",
          autoClose: 3000,
        });
        setIsLoading(false);
      });
  };

  return (
    <div className="contact-container">
      <ToastContainer />
    <div className="contact-header"><span>cont</span>act</div>
      <div className="contact-info">
        <div className="contact-left">
         <span>{joke}</span>&#128518;
        </div>
        <div className="contact-right">
          <form className="contact-form" onSubmit={onFormSubmit}>
            <div className="contact-form-row">
              <div className="contact-form-group">
                <label htmlFor="name">👤 Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="contact-form-group">
                <label htmlFor="email">📧 E-mail</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="contact-form-group">
              <label htmlFor="subject">📝 Subject</label>
              <input
                type="text"
                name="subject"
                id="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
            <div className="contact-form-group">
              <label htmlFor="message">💬 Message</label>
              <textarea
                className="contact-form-message"
                name="message"
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              />
            </div>
            <button
              className="contact-form-button"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "🚀 Sending..." : "Send"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
